const tr = {
  // Navbar
  'nav.home': 'Ana Sayfa',
  'nav.about': 'Hakkımızda',
  'nav.solutions': 'Çözümlerimiz',
  'nav.sectors': 'Hizmet Verdiğimiz Sektörler',
  'nav.contact': 'İletişim',
  'nav.references': 'Referanslar',
  'nav.blog': 'Blog',
  'nav.allSectors': 'Tüm Sektörler',
  
  // Solutions
  'solutions.aiAgent': 'Yapay Zeka Agent',
  'solutions.aiAgent.desc': 'Otonom karar alma sistemleri',
  'solutions.imageProcessing': 'Görüntü İşleme',
  'solutions.imageProcessing.desc': 'Nesne tanıma ve analiz',
  'solutions.decisionSupport': 'Karar Destek Sistemleri',
  'solutions.decisionSupport.desc': 'Tahminleme ve optimizasyon',
  
  // Sectors
  'sectors.retail': 'Perakende',
  'sectors.finance': 'Finans',
  'sectors.automotive': 'Otomotiv',
  'sectors.mobility': 'Mobilite ve Akıllı Şehir',
  'sectors.energy': 'Enerji',
  'sectors.service': 'Hizmet & İK',
  'sectors.public': 'Kamu',
  'sectors.manufacturing': 'Üretim & İmalat',
  'sectors.health': 'Sağlık',
  
  // Footer
  'footer.corporate': 'Kurumsal',
  'footer.solutions': 'Çözümlerimiz',
  'footer.sectors': 'Sektörler',
  'footer.contact': 'İletişim',
  'footer.description': 'Yapay zeka ve veri bilimi çözümleriyle işletmenizi geleceğe taşıyoruz.',
  'footer.copyright': 'Copyright © 2021 Tüm Hakları Saklıdır. Datafors.',
  'footer.address': 'Adres',
  'footer.phone': 'Telefon',
  'footer.email': 'E-posta',
  
  // Home Page
  'home.hero.title1': 'Veriyi Bilgiye,',
  'home.hero.title2': 'Bilgiyi Değere Dönüştürüyoruz!',
  'home.hero.subtitle': 'DATAFORS',
  
  'home.about.title': 'Datafors Yapay Zeka A.Ş.',
  'home.about.p1': 'Datafors; kamu kurumları, küresel organizasyonlar ve farklı sektörlerdeki öncü şirketlerin karmaşık problemlerine; görüntü işleme, matematiksel optimizasyon, karar destek sistemleri ve yapay zeka teknolojileri ile uçtan uca çözümler sunan bir teknoloji ve inovasyon üretim merkezidir.',
  'home.about.p2': 'Türkiye\'de yapay zeka odaklı girişimlerin henüz sınırlı olduğu 2016 yılında fikri temelleri atılan Datafors, yolculuğuna akademik titizlik ve Ar-Ge vizyonuyla başlamıştır. 2020 yılına gelindiğinde; Endüstriyel Üretim, IoT, İstatistik, Fizik ve Optimizasyon alanlarında uzman, hem akademik literatür hem de reel sektörün dinamiklerine hâkim çekirdek bir ekip tarafından Boğaziçi University Technoparkı bünyesinde Datafors Yapay Zeka A.Ş. olarak resmileşmiştir.',
  'home.about.p3': 'Akademik dünya ile kurduğu stratejik bağlar ve alanında uzman akademisyenlerle oluşturduğu multidisipliner araştırma grupları sayesinde; Finans\'tan Enerji\'ye, İnsan Kaynakları\'ndan Otomotiv\'e kadar geniş bir yelpazede "tailor-made" inovatif çözümler tasarlamaktadır.',
  'home.about.expertise': 'Uzmanlık alanlarımız:',
  'home.about.expertise1': 'Yapay Zeka Agent Sistemleri ile kurumsal karar alma süreçlerinin ve iş akışlarının sürdürülmesi, otomasyonu, iyileştirilmesi.',
  'home.about.expertise2': 'İleri Düzey Görüntü İşleme Teknolojileri ile gerçek zamanlı görüntü analizi ve tanıma sistemleri.',
  'home.about.expertise3': 'Akıllı Karar Destek Sistemleri ile karmaşık süreçlerin veriye dayalı yönetimi ve optimizasyonu',
  'home.about.button': 'Hakkımızda',
  
  'home.competencies.title': 'Yetkinliklerimiz',
  'home.competencies.statistical.title': 'İstatistiksel Karar Destek Sistemleri',
  'home.competencies.statistical.desc': 'Karar süreçlerindeki hata riskini minimize etmek ve operasyonel verimliliği artırmak amacıyla, veriye dayalı matematiksel modeller geliştiriyoruz.',
  'home.competencies.statistical.item1': 'Çok boyutlu veri analizi',
  'home.competencies.statistical.item2': 'Tahminleme modelleri',
  'home.competencies.statistical.item3': 'Risk analizi ve optimizasyon',
  
  'home.competencies.image.title': 'Görüntü İşleme',
  'home.competencies.image.desc': 'Derin öğrenme ve bilgisayarlı görü teknolojileri ile görsel verileri anlamlı bilgiye dönüştüren ileri teknoloji çözümler.',
  'home.competencies.image.item1': 'Nesne tanıma ve tespit',
  'home.competencies.image.item2': 'Yüz tanıma sistemleri',
  'home.competencies.image.item3': 'Kalite kontrol otomasyonu',
  
  'home.competencies.optimization.title': 'Matematiksel Optimizasyon',
  'home.competencies.optimization.desc': 'Karmaşık iş süreçlerini matematiksel modellere dönüştürerek kaynak kullanımını optimize ediyor ve maliyetleri minimize ediyoruz.',
  'home.competencies.optimization.item1': 'Rota optimizasyonu',
  'home.competencies.optimization.item2': 'Kaynak planlama',
  'home.competencies.optimization.item3': 'Üretim çizelgeleme',
  
  'home.competencies.ai.title': 'Yapay Zeka ve Makine Öğrenmesi',
  'home.competencies.ai.desc': 'Derin öğrenme algoritmaları ve özel yapay zeka modelleri ile karmaşık problemlere akıllı çözümler üretiyoruz.',
  'home.competencies.ai.item1': 'Doğal dil işleme',
  'home.competencies.ai.item2': 'Tahminsel bakım sistemleri',
  'home.competencies.ai.item3': 'Anomali tespiti',
  
  'home.competencies.iot.title': 'IoT ve Veri Entegrasyonu',
  'home.competencies.iot.desc': 'Nesnelerin interneti teknolojileri ile gerçek zamanlı veri toplama, işleme ve analiz sistemleri kuruyoruz.',
  'home.competencies.iot.item1': 'Sensör veri toplama',
  'home.competencies.iot.item2': 'Gerçek zamanlı izleme',
  'home.competencies.iot.item3': 'Veri entegrasyon platformları',
  
  'home.competencies.research.title': 'Akademik Ar-Ge',
  'home.competencies.research.desc': 'Üniversiteler ve araştırma kurumlarıyla işbirliği içinde, bilimsel yöntemlerle yenilikçi çözümler geliştiriyoruz.',
  'home.competencies.research.item1': 'TÜBİTAK destekli projeler',
  'home.competencies.research.item2': 'Akademik yayınlar',
  'home.competencies.research.item3': 'Bilgi transferi',
  
  'home.why.title': 'Datafors ile Sektöre Özgü Mükemmellik',
  'home.why.subtitle': 'Akademik mükemmellik ve endüstriyel deneyimimizle, veriye dayalı çözümler sunarak işletmenizi geleceğe taşıyoruz.',
  'home.why.academic.title': 'Akademik Temelli Yaklaşım',
  'home.why.academic.desc': 'Boğaziçi University Technopark bünyesinde, akademik titizlik ve bilimsel yöntemlerle geliştirdiğimiz çözümler, kanıta dayalı ve ölçülebilir sonuçlar üretir.',
  'home.why.custom.title': 'Özelleştirilmiş Çözümler',
  'home.why.custom.desc': 'Her kurumun benzersiz ihtiyaçlarına özel "tailor-made" çözümler tasarlıyoruz, hazır paket yerine size özel sistemler geliştiriyoruz.',
  'home.why.measurable.title': 'Ölçülebilir Sonuçlar',
  'home.why.measurable.desc': 'Veri odaklı yaklaşımımızla operasyonel verimliliği artırıyor, maliyetleri optimize ediyor ve somut iş değeri yaratıyoruz.',
  'home.why.expert.title': 'Uzman Ekip',
  'home.why.expert.desc': 'Yapay zeka, veri bilimi, optimizasyon ve görüntü işleme alanlarında uzman, multidisipliner ekibimizle karmaşık problemlere çözüm üretiyoruz.',
  'home.why.button': 'Daha Fazla Bilgi',
  
  'home.solutions.title': 'Ürün ve Çözümlerimiz',
  'home.solutions.subtitle': 'İşletmenizin ihtiyaçlarına özel, yapay zeka destekli çözümlerimizle operasyonel verimliliğinizi artırın',
  'home.solutions.aiAgent.title': 'Yapay Zeka Agent',
  'home.solutions.aiAgent.desc': 'Otonom karar alma ve iş süreçlerini optimize eden yapay zeka agent sistemleri ile operasyonel verimliliğinizi artırın.',
  'home.solutions.aiAgent.item1': 'Otonom karar alma sistemleri',
  'home.solutions.aiAgent.item2': 'İş akışı otomasyonu',
  'home.solutions.aiAgent.item3': 'Akıllı süreç yönetimi',
  'home.solutions.aiAgent.button': 'Detaylı İncele',
  
  'home.solutions.image.title': 'Görüntü İşleme Teknolojileri',
  'home.solutions.image.desc': 'Derin öğrenme ve bilgisayarlı görü ile görsel verileri anlamlı bilgiye dönüştüren ileri teknoloji çözümler.',
  'home.solutions.image.item1': 'Nesne tanıma ve tespit',
  'home.solutions.image.item2': 'Yüz tanıma sistemleri',
  'home.solutions.image.item3': 'Kalite kontrol otomasyonu',
  
  'home.solutions.decision.title': 'Karar Destek Sistemleri',
  'home.solutions.decision.desc': 'Veriye dayalı matematiksel modeller ile karmaşık iş süreçlerinizi optimize edin ve stratejik kararlar alın.',
  'home.solutions.decision.item1': 'Tahminleme modelleri',
  'home.solutions.decision.item2': 'Risk analizi ve optimizasyon',
  'home.solutions.decision.item3': 'Stratejik planlama araçları',
  
  'home.solutions.note': 'Tüm çözümlerimiz, işletmenizin özel ihtiyaçlarına göre özelleştirilebilir',
  'home.solutions.contactButton': 'Bizimle İletişime Geçin',
  
  'home.sectors.title': 'Hizmet Verdiğimiz Sektörler',
  'home.sectors.subtitle': 'Farklı sektörlerdeki öncü kurumlara yapay zeka ve veri bilimi çözümleriyle değer katıyoruz',
  'home.sectors.retail.desc': 'Müşteri analizi, stok optimizasyonu ve satış tahmini',
  'home.sectors.finance.desc': 'Risk analizi, fraud tespiti ve portföy optimizasyonu',
  'home.sectors.automotive.desc': 'Kalite kontrol, üretim optimizasyonu ve tahminsel bakım',
  'home.sectors.mobility.desc': 'Trafik yönetimi, rota optimizasyonu ve akıllı ulaşım',
  'home.sectors.energy.desc': 'Talep tahmini, şebeke optimizasyonu ve enerji verimliliği',
  'home.sectors.service.desc': 'Yetenek yönetimi, performans analizi ve işgücü planlaması',
  'home.sectors.public.desc': 'Dijital dönüşüm, veri analizi ve akıllı şehir çözümleri',
  'home.sectors.manufacturing.desc': 'Üretim optimizasyonu, kalite kontrol otomasyonu ve tahminsel bakım',
  
  // About Page
  'about.hero.title': 'Hakkımızda',
  'about.who.title': 'Biz Kimiz?',
  'about.who.p1': 'Datafors; kamu kurumları, küresel organizasyonlar ve farklı sektörlerdeki öncü şirketlerin karmaşık problemlerine; görüntü işleme, matematiksel optimizasyon, karar destek sistemleri ve yapay zeka teknolojileri ile uçtan uca çözümler sunan bir teknoloji ve inovasyon üretim merkezidir.',
  'about.who.p2': 'Türkiye\'de yapay zeka odaklı girişimlerin henüz sınırlı olduğu 2016 yılında fikri temelleri atılan Datafors, yolculuğuna akademik titizlik ve Ar-Ge vizyonuyla başlamıştır. 2020 yılında Boğaziçi Üniversitesi Teknopark bünyesinde Datafors Yapay Zeka A.Ş. olarak resmileşti.',
  'about.who.p3': 'Akademik dünya ile kurduğu stratejik bağlar ve alanında uzman akademisyenlerle oluşturduğu multidisipliner araştırma grupları sayesinde; Finans\'tan Enerji\'ye, İnsan Kaynakları\'ndan Otomotiv\'e kadar geniş bir yelpazede "tailor-made" inovatif çözümler tasarlamaktadır.',
  
  'about.vision.title': 'Vizyonumuz',
  'about.vision.desc': 'Türkiye\'nin yapay zeka ve veri bilimi alanında öncü teknoloji merkezi olmak; akademik mükemmellik ile endüstriyel uygulamayı birleştirerek kurumların dijital dönüşüm yolculuğunda güvenilir bir çözüm ortağı olmak.',
  
  'about.mission.title': 'Misyonumuz',
  'about.mission.desc': 'Karmaşık iş problemlerini, akademik titizlik ve sektörel deneyimimizle birleştirerek ölçülebilir değer yaratan yapay zeka çözümlerine dönüştürmek. Her projede "tailor-made" yaklaşımıyla, kurumların benzersiz ihtiyaçlarına özel, sürdürülebilir ve ölçeklenebilir sistemler geliştirmek.',
  
  'about.values.title': 'Değerlerimiz',
  'about.values.innovation.title': 'İnovasyon',
  'about.values.innovation.desc': 'Sürekli araştırma ve geliştirme ile sektörün önünde olmak, yenilikçi çözümler üretmek.',
  'about.values.reliability.title': 'Güvenilirlik',
  'about.values.reliability.desc': 'Akademik temelli yaklaşım ve kanıta dayalı çözümlerle müşterilerimize güven vermek.',
  'about.values.collaboration.title': 'İşbirliği',
  'about.values.collaboration.desc': 'Müşterilerimiz ve akademik ortaklarımızla güçlü, uzun vadeli ilişkiler kurmak.',
  'about.values.focus.title': 'Odaklanma',
  'about.values.focus.desc': 'Her projede müşteri ihtiyaçlarına özel, ölçülebilir sonuçlar üretmeye odaklanmak.',
  'about.values.excellence.title': 'Akademik Mükemmellik',
  'about.values.excellence.desc': 'En yüksek kalite standartlarını bilimsel yöntem ve akademik titizlikle korumak.',
  'about.values.development.title': 'Sürekli Gelişim',
  'about.values.development.desc': 'Teknoloji ve sektör trendlerini takip ederek kendimizi sürekli geliştirmek.',
  
  'about.academic.title': 'Akademik İşbirlikleri',
  'about.academic.bogazici.title': 'Boğaziçi Üniversitesi',
  'about.academic.bogazici.desc': 'Technopark içinde faaliyet gösteriyor, üniversitenin araştırma altyapısından ve akademik bilgi birikiminden faydalanıyoruz.',
  'about.academic.rd.title': 'Ar-Ge Projeleri',
  'about.academic.rd.desc': 'TÜBİTAK destekli projeler ve ulusal ve uluslararası akademik araştırma gruplarıyla ortak çalışmalar yürütüyoruz.',
  'about.academic.transfer.title': 'Bilgi Transferi',
  'about.academic.transfer.desc': 'Akademik literatürdeki en güncel gelişmeleri endüstriyel uygulamalara aktarıyoruz.',
  
  'about.references.title': 'Referanslarımız',
  
  // Contact Page
  'contact.hero.title': 'İletişim',
  'contact.hero.subtitle': 'Projeleriniz için bizimle iletişime geçin. Uzman ekibimiz en kısa sürede size geri dönüş yapacaktır.',
  
  'contact.info.title': 'İletişim Bilgileri',
  'contact.info.address.title': 'Adres',
  'contact.info.address.line1': 'Boğaziçi Üniversitesi Teknopark',
  'contact.info.address.line2': '2 / 5 / 202',
  'contact.info.address.line3': 'İstanbul, Türkiye',
  'contact.info.phone.title': 'Telefon',
  'contact.info.phone.number': '0216 606 22 09',
  'contact.info.email.title': 'E-posta',
  'contact.info.email.number': 'info@datafors.com',
  'contact.info.hours.title': 'Çalışma Saatleri',
  'contact.info.hours.weekday': 'Pazartesi - Cuma: 09:00 - 18:00',
  'contact.info.hours.weekend': 'Cumartesi - Pazar: Kapalı',
  'contact.info.social.title': 'Sosyal Medya',
  
  'contact.form.title': 'Bize Ulaşın',
  'contact.form.name': 'Ad Soyad',
  'contact.form.name.placeholder': 'Adınız ve soyadınız',
  'contact.form.email': 'E-posta',
  'contact.form.email.placeholder': 'ornek@email.com',
  'contact.form.phone': 'Telefon',
  'contact.form.phone.placeholder': '0 (5XX) XXX XX XX',
  'contact.form.company': 'Şirket',
  'contact.form.company.placeholder': 'Şirket adınız',
  'contact.form.subject': 'Konu',
  'contact.form.subject.placeholder': 'Konu seçiniz',
  'contact.form.subject.ai': 'Yapay Zeka Çözümleri',
  'contact.form.subject.image': 'Görüntü İşleme',
  'contact.form.subject.decision': 'Karar Destek Sistemleri',
  'contact.form.subject.general': 'Genel Bilgi',
  'contact.form.subject.other': 'Diğer',
  'contact.form.message': 'Mesajınız',
  'contact.form.message.placeholder': 'Mesajınızı buraya yazın... (Maksimum 500 karakter)',
  'contact.form.message.limit': 'Maksimum 500 karakter',
  'contact.form.submit': 'Gönder',
  'contact.form.success': 'Mesajınız başarıyla gönderildi! En kısa sürede size dönüş yapacağız.',
  'contact.form.error': 'Bir hata oluştu. Lütfen tekrar deneyin.',
  'contact.form.required': '*',
  
  'contact.map.title': 'Ofisimiz',
  
  'contact.faq.title': 'Sık Sorulan Sorular',
  'contact.faq.q1': 'Projeler için ortalama teslim süresi nedir?',
  'contact.faq.a1': 'Proje süreleri, projenin kapsamına ve karmaşıklığına göre değişmektedir. Küçük ölçekli projeler 2-4 hafta, orta ölçekli projeler 2-3 ay, büyük ölçekli projeler ise 6 ay ve üzeri sürebilir. İlk görüşmede size detaylı bir zaman planı sunuyoruz.',
  'contact.faq.q2': 'Hangi sektörlere hizmet veriyorsunuz?',
  'contact.faq.a2': 'Perakende, finans, enerji, otomotiv, sağlık, kamu, hizmet ve imalat sektörlerinde geniş deneyimimiz bulunmaktadır. Her sektöre özgü ihtiyaçlara uygun çözümler geliştirmekteyiz.',
  'contact.faq.q3': 'Proje sonrası destek sağlıyor musunuz?',
  'contact.faq.a3': 'Evet, tüm projelerimizde proje sonrası teknik destek ve bakım hizmeti sunuyoruz. Sistemlerinizin sorunsuz çalışması için düzenli güncellemeler ve iyileştirmeler yapıyoruz.',
  
  blog: {
    title: 'Blog',
    subtitle: 'Yapay zeka, veri bilimi ve teknoloji dünyasından güncel içerikler',
    readMore: 'Devamını Oku',
    readTime: 'dk okuma',
    allCategories: 'Tüm Kategoriler',
    categories: 'Kategoriler',
    categoryAI: 'Yapay Zeka',
    categoryVision: 'Görüntü İşleme',
    categoryDecision: 'Karar Destek',
    categorySector: 'Sektörel',
    categoryOther: 'Diğer',
    newsletterTitle: 'Blog Güncellemelerini Kaçırmayın',
    newsletterSubtitle: 'Yapay zeka ve teknoloji dünyasından en güncel haberleri e-posta ile alın',
    emailPlaceholder: 'E-posta adresiniz',
    subscribe: 'Abone Ol',
    posts: {
      post1: {
        title: 'Yapay Zeka ve İş Süreçleri: Dijital Dönüşümün Geleceği',
        excerpt: 'Yapay zeka teknolojilerinin iş süreçlerine entegrasyonu, şirketlerin operasyonel verimliliğini nasıl artırıyor? Gerçek dünya örnekleri ve uygulamalar...',
        date: '15 Ocak 2025',
        category: 'Yapay Zeka'
      },
      post2: {
        title: 'Görüntü İşleme Teknolojileri ile Kalite Kontrolde Yeni Dönem',
        excerpt: 'Üretim süreçlerinde görüntü işleme ve derin öğrenme algoritmalarının kullanımı, kalite kontrol süreçlerini nasıl dönüştürüyor?',
        date: '10 Ocak 2025',
        category: 'Görüntü İşleme'
      },
      post3: {
        title: 'Karar Destek Sistemleri: Veriye Dayalı Yönetim',
        excerpt: 'Büyük veri ve makine öğrenmesi ile desteklenen karar destek sistemleri, yöneticilerin stratejik kararlarını nasıl güçlendiriyor?',
        date: '5 Ocak 2025',
        category: 'Karar Destek'
      },
      post4: {
        title: 'Perakende Sektöründe Talep Tahmini ve Optimizasyon',
        excerpt: 'Yapay zeka destekli talep tahmini sistemleri, perakende şirketlerinin stok yönetimi ve fiyatlandırma stratejilerini nasıl optimize ediyor?',
        date: '28 Aralık 2024',
        category: 'Sektörel'
      },
      post5: {
        title: 'Enerji Sektöründe Yapay Zeka Uygulamaları',
        excerpt: 'Enerji üretimi ve dağıtımında yapay zeka ve optimizasyon algoritmalarının kullanımı, verimliliği nasıl artırıyor?',
        date: '20 Aralık 2024',
        category: 'Sektörel'
      },
      post6: {
        title: 'OCR ve Doküman İşleme: Dijital Dönüşümün Temeli',
        excerpt: 'Optik karakter tanıma ve akıllı doküman işleme teknolojileri, kurumların dijital dönüşüm süreçlerini nasıl hızlandırıyor?',
        date: '15 Aralık 2024',
        category: 'Görüntü İşleme'
      }
    }
  },
  
  references: {
    title: 'Referanslarımız',
    subtitle: 'Türkiye\'nin önde gelen kurumları ve şirketleri ile gerçekleştirdiğimiz başarılı projeler',
    stats: {
      projects: 'Tamamlanan Proje',
      clients: 'Kurumsal Müşteri',
      sectors: 'Farklı Sektör',
      satisfaction: 'Müşteri Memnuniyeti'
    },
    institutions: 'Birlikte Çalıştığımız Kurumlar',
    successStories: {
      title: 'Başarı Hikayeleri',
      retail: {
        title: 'Perakende Sektörü',
        description: 'Türkiye\'nin önde gelen perakende zincirlerinden birine geliştirdiğimiz talep tahmini ve fiyat optimizasyon sistemi sayesinde stok maliyetlerinde %25 azalma sağlandı.',
        result: '%25 Maliyet Azalması'
      },
      finance: {
        title: 'Finans Sektörü',
        description: 'Bir büyük bankaya sunduğumuz görüntü işleme ve OCR çözümü sayesinde belge işleme süreleri %70 azaldı ve hata oranı %90 düştü.',
        result: '%70 Zaman Tasarrufu'
      },
      public: {
        title: 'Kamu Sektörü',
        description: 'Kamu kurumuna geliştirdiğimiz yapay zeka destekli karar destek sistemi sayesinde operasyonel verimlilikte %40 artış sağlandı.',
        result: '%40 Verimlilik Artışı'
      }
    },
    testimonials: {
      title: 'Müşterilerimiz Ne Diyor?',
      testimonial1: {
        name: 'Ahmet Yılmaz',
        position: 'CTO, Perakende Şirketi',
        text: 'Datafors ekibi ile çalışmak harika bir deneyimdi. Akademik yaklaşımları ve sektörel deneyimleri sayesinde karmaşık problemlerimize pratik ve etkili çözümler ürettiler. Özellikle talep tahmini sistemimiz işimizi tamamen değiştirdi.'
      },
      testimonial2: {
        name: 'Ayşe Demir',
        position: 'Dijital Dönüşüm Müdürü, Finans',
        text: 'Görüntü işleme ve OCR çözümleri operasyonlarımızı hızlandırdı ve hata oranlarını minimuma indirdi. Datafors\'un teknik uzmanlığı ve müşteri odaklı yaklaşımı projenin başarısında kritik rol oynadı.'
      }
    },
    cta: {
      title: 'Siz de Başarı Hikayemizin Parçası Olun',
      description: 'Yapay zeka ve veri bilimi çözümlerimizle işinizi bir üst seviyeye taşıyın. Uzman ekibimiz sizin için en uygun çözümü tasarlamaya hazır.',
      button: 'Bizimle İletişime Geçin'
    }
  },
  
  decisionSupport: {
    hero: {
      title: 'Karar Destek Sistemleri',
      subtitle: 'Alternatif Aksiyonları Ölçülebilir Sonuçlarla Karşılaştırın'
    },
    intro: 'Karar destek sistemleri; raporlama yapmanın ötesinde, alternatif aksiyonları ölçülebilir sonuçlarla karşılaştırır. Akademik literatürde de yapay zekâ tabanlı karar destek; teknik doğruluk kadar yönetişim, etik, şeffaflık boyutlarıyla ele alınır.',
    solutions: {
      title: 'Çözümlerimiz',
      investment: {
        title: 'Yatırım Optimizasyonu & Teşvik Simülasyonu',
        subtitle: 'Yatırımın katma değere dönüşümünü ölçmek ve kamu teşviklerinin en doğru kombinasyonunu belirlemek',
        scope: 'Kapsam',
        question1: '"Bu yatırımı hangi il/bölgede yapmak daha avantajlı?"',
        question2: '"Yatırım hangi teşvik kapsamına daha uygun ve hangi şartlarda?"',
        question3: '"Teşvik etkisi nakit akışını ve geri dönüşü ne kadar iyileştiriyor?"',
        question4: '"Bütçem sınırlıysa, hangi yatırım kalemi önce değer üretir?"',
        deliverable1: {
          title: 'Teşvik Uygunluk Simülasyonu',
          desc: 'Bölge–sektör–yatırım konusu kırılımında teşvik uygunluk analizi ve kapsam simülasyonu'
        },
        deliverable2: {
          title: 'Katma Değer Dönüşüm Raporu',
          desc: 'Yatırım → kapasite/verim/kalite → katma değer zinciri analizi'
        },
        deliverable3: {
          title: 'Finansal Geri Dönüş Seti',
          desc: 'ROI, NPV, IRR, geri ödeme hesaplamaları (teşvikli/teşviksiz karşılaştırmalı)'
        },
        deliverable4: {
          title: 'Yatırım Portföyü Önceliklendirme',
          desc: 'Bütçe ve takvim kısıtları altında en yüksek etki yaratan kalemlerin sıralaması'
        },
        deliverable5: {
          title: 'Risk & Hassasiyet Analizi',
          desc: 'Sonucu en çok etkileyen değişkenler ve risk azaltım önerileri'
        },
        deliverable6: {
          title: 'Uygulama Yol Haritası',
          desc: 'Doküman hazırlığı, takvim, kontrol noktaları ve aksiyon planı'
        },
        benefits: 'Faydalar',
        benefit1: 'Teşvikten maksimum fayda',
        benefit2: 'Yatırım kararı hızlanır',
        benefit3: 'Sermaye verimliliği artar',
        benefit4: 'Nakit akışı daha güvenli',
        benefit5: 'Kamu mantığına uyum',
        benefit6: 'Uygulanabilirlik artar'
      },
      demand: {
        title: 'Talep Tahmini & Fiyat Optimizasyonu',
        subtitle: 'Büyürken stok-servis seviyesini ve marj dengesini bozmaz',
        scope: 'Kapsam',
        item1: 'SKU/mağaza/kanal bazlı tahmin (mevsimsellik, kampanya, fiyat etkisi, stok kırılmaları)',
        item2: 'Kısıtlar altında fiyat önerisi (marj hedefi, rekabet, stok, tedarik, raf ömrü)',
        item3: 'Kampanya simülasyonu: "indirim derinliği × süre × stok" etkisi',
        deliverable1: {
          title: 'Tahmin Çıktıları',
          desc: 'SKU × mağaza × gün/hafta bazlı satış tahmini + güven aralığı (belirsizlik bandı)'
        },
        deliverable2: {
          title: 'Fiyat Önerileri',
          desc: 'Ürün bazında önerilen fiyat, beklenen hacim etkisi, beklenen marj etkisi'
        },
        deliverable3: {
          title: 'Kampanya Simülasyonu',
          desc: 'Kampanya senaryoları (fiyat/indirim/süre) ve beklenen ciro‑marj‑stok etkisi'
        },
        deliverable4: {
          title: 'Sipariş Önerileri',
          desc: 'Tahmine dayalı önerilen sipariş miktarı ve stok hedefleri'
        },
        deliverable5: {
          title: 'Uyarılar',
          desc: 'Stok‑out riski, aşırı stok riski, anomali/süpheli talep sıçraması, kampanya sapmaları'
        },
        deliverable6: {
          title: 'Dashboard & API',
          desc: 'Yönetici paneli + ERP/POS entegrasyonu için servis uçları'
        },
        benefits: 'Faydalar',
        benefit1: 'Stok‑out azalır, hizmet seviyesi artar',
        benefit2: 'Aşırı stok ve atık azalır',
        benefit3: 'Marj optimizasyonu',
        benefit4: 'Kampanya verimliliği artar',
        benefit5: 'Tedarik ve operasyon planı gelişir',
        benefit6: 'Rekabet ve pazar dinamiklerine uyum sağlanır'
      },
      energy: {
        title: 'Enerji İletim & Kapasite Optimizasyonu',
        subtitle: 'Güvenilirlik ve maliyet hedeflerini birlikte yönetmek',
        scope: 'Kapsam',
        item1: 'Talep/üretim öngörüsü ile kapasite planlaması',
        item2: 'Şebeke/operasyon kısıtları altında işletim senaryoları',
        item3: 'Kritik varlık & bakım önceliklendirme',
        deliverable1: {
          title: 'Talep / Yük Tahmini',
          desc: 'Bölge/trafo merkezi/hat bazında kısa‑orta vadeli yük tahminleri + belirsizlik bandı'
        },
        deliverable2: {
          title: 'Kapasite Planı',
          desc: 'Güç artırımı, yeni hat/trafo yatırımı, reaktif güç iyileştirme seçenekleri'
        },
        deliverable3: {
          title: 'İşletim Optimizasyonu',
          desc: 'Kısıtlar altında (termik limitler, gerilim limitleri, N‑1) önerilen işletim/distribütör planları'
        },
        deliverable4: {
          title: 'Kayıp‑Kaçak Raporları',
          desc: 'Teknik kayıpların analizi ve azaltım aksiyonları'
        },
        deliverable5: {
          title: 'Varlık Sağlığı & Bakım',
          desc: 'Arıza riski, kritiklik, bakım maliyeti önceliklendirme listeleri'
        },
        deliverable6: {
          title: 'Erken Uyarılar',
          desc: 'Aşırı yük, gerilim sapması, kritik ekipman riski, tıkanma noktaları'
        },
        benefits: 'Faydalar',
        benefit1: 'Kesinti riskini azaltır',
        benefit2: 'Yatırım geri dönüşünü netleştir',
        benefit3: 'İşletme maliyetlerini düşürür',
        benefit4: 'Varlık ömrünü uzatır',
        benefit5: 'Planlama doğruluğunu artırır',
        benefit6: 'Regülasyon ve raporlama uyumunu kolaylaştırır'
      }
    },
    cta: {
      title: 'Karar Destek Sistemlerimiz Hakkında Daha Fazla Bilgi Alın',
      subtitle: 'Veri odaklı kararlarla işinizi büyütün',
      button: 'İletişime Geçin'
    }
  },
  
  imageProcessing: {
    hero: {
      title: 'Görüntü İşleme Çözümleri',
      subtitle: 'Görsel Veriyi KPI\'ya Dönüştüren Akıllı Sistemler'
    },
    intro: 'En pahalı operasyon problemleri genellikle "geç tespit edilen" durumlardır. Görüntü işleme çözümlerimiz kamera ve görsel belge verisini KPI\'ya dönüştürerek güvenlik, kalite ve verimliliği ölçülebilir hale getirir.',
    capabilities: {
      title: 'Yeteneklerimiz',
      faceRecognition: {
        title: 'Yüz Tanıma / Biyometrik Doğrulama',
        desc: 'Yetkilendirme, erişim kontrolü, saha kimlik doğrulama çözümleri. GDPR odaklı tasarım ile güvenli ve uyumlu sistemler.'
      },
      plateRecognition: {
        title: 'Plaka Tanıma',
        desc: 'Araç plakalarının otomatik tanınması ve kayıt altına alınması. Otopark yönetimi, güvenlik kontrol noktaları ve trafik izleme sistemleri için gerçek zamanlı plaka okuma çözümleri.'
      },
      sceneUnderstanding: {
        title: 'Sahne Anlama',
        desc: 'Kalabalık yoğunluğu, kuyruk analizi, tehlikeli alan ihlali ve olay tespiti ile operasyonel güvenlik ve verimlilik.'
      },
      objectRecognition: {
        title: 'Nesne Tanıma & İzleme',
        desc: 'Kişi/araç/equipment takibi, sayma, güvenlik ve iş sağlığı senaryoları için gerçek zamanlı izleme sistemleri.'
      },
      ocr: {
        title: 'OCR (Akıllı Doküman İşleme)',
        desc: 'Fatura/irsaliye/formlardan alan çıkarımı, doğrulama ve otomatik ERP kaydı ile dijital dönüşüm.'
      },
      analysis3d: {
        title: '3D Analiz',
        desc: 'Derinlik bazlı ölçüm, hacim/mesafe hesaplama, yerleşim doğrulama ve kalite kontrol çözümleri.'
      },
      syntheticImage: {
        title: 'Sentetik Görsel & Görüntü İyileştirme',
        desc: 'Düşük ışık/bulanıklık koşullarında iyileştirme; veri kıtlığında sentetik veri ile model dayanıklılığı.'
      },
      satelliteAnalysis: {
        title: 'Uydu Görüntü Analizi',
        desc: 'Şehir gelişimi, arazi kullanımı, değişim tespiti, çevresel izleme ve tarımsal analiz için uydu görüntülerinden veri çıkarımı ve geleceğe yönelik tahminler.'
      },
      videoAnalysis: {
        title: 'Video Görüntü Analizi',
        desc: 'Gerçek zamanlı video akışlarından hareket analizi, olay tespiti, davranış tanıma ve otomatik alarm sistemleri.'
      }
    },
    sectoral: {
      title: 'Sektörel Uygulamalar',
      retail: {
        title: 'Perakende',
        desc: 'Müşteri deneyimi optimizasyonu için kuyruk analizi ve yoğunluk takibi'
      },
      service: {
        title: 'Hizmet & Tesis Yönetimi',
        desc: 'Saha güvenliği ve iş sağlığı denetimi'
      },
      manufacturing: {
        title: 'Üretim',
        desc: 'Kalite kontrol ve hata tespiti sistemleri'
      },
      public: {
        title: 'Kamu',
        desc: 'Güvenlik ve asayiş uygulamaları'
      },
      health: {
        title: 'Sağlık',
        desc: 'Belge otomasyonu ve hasta takibi sistemleri'
      },
      logistics: {
        title: 'Lojistik',
        desc: 'Araç ve kargo takibi, depo yönetimi'
      }
    },
    cta: {
      title: 'Görüntü İşleme Çözümlerimiz Hakkında Daha Fazla Bilgi Alın',
      subtitle: 'Görsel veriyi kullanarak operasyonlarınızı optimize edin',
      button: 'Bizimle İletişime Geçin'
    }
  },
  
  allSectors: {
    hero: {
      title: 'Endüstrilerimiz',
      subtitle: 'Farklı sektörlerde AI ve veri bilimi çözümleri sunuyoruz'
    },
    intro: 'Datafors, AI, görüntü işleme, matematiksel optimizasyon ve karar destek sistemleriyle farklı sektörlerdeki karmaşık problemleri uçtan uca çözümler. Her sektörün ihtiyacına göre özelleştirilmiş, terzi usulü çözümler geliştiriyoruz.',
    sectors: {
      retail: {
        title: 'Perakende ve Dijital Ticaret',
        desc: 'Müşteri analizi, stok optimizasyonu ve satış tahmini',
        feature1: 'Hassas talep tahmini ve stok optimizasyonu',
        feature2: 'Dinamik fiyatlandırma ve promosyon stratejileri',
        feature3: 'Müşteri davranış analizi ve segmentasyon',
        button: 'Detaylı İncele'
      },
      finance: {
        title: 'Finans ve Bankacılık',
        desc: 'Risk analizi, fraud tespiti ve portföy optimizasyonu',
        feature1: 'Risk analizi ve portföy optimizasyonu',
        feature2: 'Fraud tespiti ve güvenlik sistemleri',
        feature3: 'Kredi skorlama ve müşteri segmentasyonu',
        button: 'Detaylı İncele'
      },
      automotive: {
        title: 'Otomotiv',
        desc: 'Kalite kontrol, üretim optimizasyonu ve tahminsel bakım',
        feature1: 'Görüntü işleme ile kalite kontrol otomasyonu',
        feature2: 'Üretim optimizasyonu ve çizelgeleme',
        feature3: 'Tahminsel bakım ve ekipman izleme',
        button: 'Detaylı İncele'
      },
      mobility: {
        title: 'Mobilite ve Akıllı Şehir',
        desc: 'Trafik yönetimi, rota optimizasyonu ve akıllı ulaşım',
        feature1: 'Akıllı trafik yönetimi ve optimizasyon',
        feature2: 'Rota planlama ve filo yönetimi',
        feature3: 'IoT tabanlı şehir altyapısı izleme',
        button: 'Detaylı İncele'
      },
      energy: {
        title: 'Enerji',
        desc: 'Talep tahmini, şebeke optimizasyonu ve yenilenebilir enerji entegrasyonu',
        feature1: 'Enerji talep tahmini ve yük dengeleme',
        feature2: 'Şebeke optimizasyonu ve akıllı sayaç analizi',
        feature3: 'Yenilenebilir enerji entegrasyonu',
        button: 'Detaylı İncele'
      },
      service: {
        title: 'Hizmet ve İnsan Kaynakları',
        desc: 'Yetenek yönetimi, performans analizi ve işgücü planlaması',
        feature1: 'Yetenek yönetimi ve aday eşleştirme',
        feature2: 'Performans analizi ve çalışan memnuniyeti',
        feature3: 'İşgücü planlaması ve vardiya optimizasyonu',
        button: 'Detaylı İncele'
      },
      public: {
        title: 'Kamu',
        desc: 'Dijital dönüşüm, veri analizi ve akıllı şehir çözümleri',
        feature1: 'Dijital dönüşüm ve e‑devlet çözümleri',
        feature2: 'Veri analizi ve karar destek sistemleri',
        feature3: 'Akıllı şehir altyapı yönetimi',
        button: 'Detaylı İncele'
      },
      manufacturing: {
        title: 'Üretim ve İmalat',
        desc: 'Üretim optimizasyonu, kalite kontrol otomasyonu ve tahminsel bakım',
        feature1: 'Üretim optimizasyonu ve çizelgeleme',
        feature2: 'Kalite kontrol otomasyonu',
        feature3: 'Tahminsel bakım ve ekipman izleme',
        button: 'Detaylı İncele'
      }
    },
    cta: {
      title: 'Sektörünüz için Özel Çözümler',
      description: 'Her sektörün kendine özgü ihtiyaçları vardır. Datafors, AI ve veri bilimi çözümlerini sizin iş gereksinimlerinize göre özelleştirir.',
      button: 'Bizimle İletişime Geçin'
    }
  },

  automotive: {
    hero: {
      title: 'Otomotiv Sektörü'
    },
    intro: 'Otomotiv sektöründe üretim süreçlerini optimize ediyor, kalite kontrolü otomasyonu sağlıyor ve tahminsel bakım sistemleri ile verimliliği artırıyoruz.',
    features: {
      predictive: {
        title: 'Tahminleyici Bakım',
        description: 'Uzaktan analiz edilen CAN-bus verileri; ticari araçlarda yakıt verimliliği, parça ömrü yönetimi ve sürüş güvenliği konularında stratejik iyileştirmeler sağlar.'
      },
      fleet: {
        title: 'Filo Yönetimi',
        description: 'Araç filosunu optimize ederek yakıt tüketimini azaltıyor, rota planlaması yapıyor ve operasyonel verimliliği artırıyoruz.'
      },
      component: {
        title: 'Komponent Kalite Kontrolü',
        description: 'Görüntü işleme teknolojileri ile üretim hattında gerçek zamanlı kalite kontrolü yapıyor, hatalı parçaları otomatik tespit ediyoruz.'
      }
    },
    excellence: {
      title: 'Datafors ile Otomotiv Sektöründe Mükemmellik',
      items: [
        'Görüntü işleme ile kalite kontrol otomasyonu',
        'Tahminsel bakım ile ekipman arızalarının önlenmesi',
        'Üretim süreçlerinin optimizasyonu ve çizelgeleme',
        'Tedarik zinciri yönetimi ve stok optimizasyonu',
        'Enerji tüketimi analizi ve verimlilik artışı',
        'Gerçek zamanlı üretim izleme ve raporlama'
      ]
    }
  },

  service: {
    hero: {
      title: 'Hizmet Sektörü ve İnsan Kaynakları'
    },
    intro: 'İnsan kaynakları süreçlerinde yapay zeka ve veri bilimi ile yetenek yönetimini optimize ediyor, çalışan memnuniyetini artırıyor ve iş gücü planlamasını güçlendiriyoruz.',
    features: {
      profiling: {
        title: 'Aday Profilleme ve Eşleştirme',
        description: 'Yapay zeka destekli aday profilleme ile pozisyon gereksinimlerine en uygun adayları belirliyor, işe alım süreçlerini hızlandırıyoruz.'
      },
      turnover: {
        title: 'Çalışan Devir Hızı Tahmini',
        description: 'Makine öğrenmesi modelleri ile çalışan devir hızını tahmin ediyor, yetenek kaybını önlemek için proaktif aksiyonlar alıyoruz.'
      },
      competency: {
        title: 'Yetkinlik ve Performans Analizi',
        description: 'Çalışan yetkinliklerini ve performansını analiz ederek kariyer gelişim planları oluşturuyor, eğitim ihtiyaçlerini belirliyoruz.'
      }
    },
    excellence: {
      title: 'Datafors ile İK Süreçlerinde Mükemmellik',
      items: [
        'Veri odaklı işe alım kararları ile doğru yetenek seçimi',
        'Çalışan memnuniyeti ve bağlılık analizi',
        'İşgücü planlaması ve vardiya optimizasyonu',
        'Eğitim ihtiyaç analizi ve gelişim planlaması',
        'Performans değerlendirme sistemleri',
        'Yetenek havuzu yönetimi ve kariyer planlama'
      ]
    }
  },

  health: {
    hero: {
      title: 'Sağlık Sektörü',
      subtitle: 'Yapay Zeka ile Sağlık Hizmetlerinde Dijital Dönüşüm'
    },
    intro: 'Sağlık sektöründe yapay zeka ve veri bilimi ile hasta bakım kalitesini artırıyor, operasyonel verimliliği optimize ediyor ve klinik karar destek sistemleri sunuyoruz.',
    features: {
      network: {
        title: 'Hasta Takip Sistemleri',
        description: 'Yapay zeka destekli hasta takip sistemleri ile tedavi süreçlerini optimize ediyor, hasta memnuniyetini artırıyoruz.'
      },
      frequency: {
        title: 'Tıbbi Görüntü Analizi',
        description: 'Derin öğrenme ile tıbbi görüntülerin otomatik analizi, erken teşhis ve tedavi planlaması için karar destek sağlıyoruz.'
      },
      delay: {
        title: 'Tahminsel Analitik',
        description: 'Hasta verilerini analiz ederek hastalık risklerini önceden tahmin ediyor, önleyici sağlık hizmetleri sunuyoruz.'
      }
    },
    excellence: {
      title: 'Datafors ile Sağlık Sektöründe Mükemmellik',
      items: [
        'Tıbbi görüntü analizi ve otomatik teşhis desteği',
        'Hasta takip ve randevu optimizasyonu',
        'İlaç etkileşimi ve yan etki tahmini',
        'Hastane kaynak yönetimi ve yatak optimizasyonu',
        'Elektronik sağlık kayıtları analizi',
        'Klinik karar destek sistemleri'
      ]
    },
    applications: {
      demand: {
        title: 'Kaynak Optimizasyonu',
        description: 'Hastane kaynaklarını optimize ederek hasta akışını iyileştiriyor, bekleme sürelerini azaltıyoruz.'
      },
      transfer: {
        title: 'Hasta Transferi',
        description: 'Hasta transfer süreçlerini optimize ederek acil durumlarda hızlı müdahale sağlıyoruz.'
      },
      fleetMgmt: {
        title: 'Ekipman Yönetimi',
        description: 'Tıbbi ekipmanların bakım ve kullanım planlaması ile operasyonel verimliliği artırıyoruz.'
      },
      scenario: {
        title: 'Senaryo Analizi',
        description: 'Farklı tedavi senaryolarını analiz ederek en uygun tedavi planını belirliyoruz.'
      }
    }
  },

  aiAgent: {
    hero: {
      title: 'Yapay Zeka Agent Çözümleri',
      subtitle: 'Otonom Karar Alma ve Akıllı Süreç Yönetimi'
    },
    intro: 'Yapay Zeka Agent sistemleri, kurumsal karar alma süreçlerinin ve iş akışlarının sürdürülmesi, otomasyonu ve iyileştirilmesini otonom olarak yöneterek otomasyonun ötesine geçer. Bu sistemler, insan hatasını azaltırken operasyonel verimliliği artırır.',
    chief: {
      title: 'Şef',
      subtitle: 'Kurumsal Karar Destek ve İş Akışı Otomasyon Platformu',
      button: 'Şef\'i Ziyaret Et',
      desc: 'Şef, kurumsal karar alma süreçlerinin ve iş akışlarının sürdürülmesi, otomasyonu ve iyileştirilmesini sağlayan yapay zeka destekli bir platformdur. Otonom karar alma yetenekleri ile karmaşık iş süreçlerini yöneterek operasyonel verimliliği artırır.',
      features: 'Ana Özellikler',
      feature1: 'Doküman ve veri işleme',
      feature2: 'İş akışı otomasyonu',
      feature3: 'Görev ve süreç yönetimi',
      feature4: 'Güvenlik ve yetkilendirme',
      module1: {
        title: 'Doküman Yönetimi',
        desc: 'Dokümanların otomatik sınıflandırılması, çıkarımı ve işlenmesi'
      },
      module2: {
        title: 'Soru-Cevap Sistemi',
        desc: 'Kurumsal veri ve dokümanlar hakkında anlık cevaplar'
      },
      module3: {
        title: 'İş Akışı Otomasyonu',
        desc: 'İş süreçlerinin otomatik yürütülmesi ve yönetimi'
      },
      module4: {
        title: 'Görev Yönetimi',
        desc: 'Görevlerin otomatik atanması, takibi ve raporlanması'
      },
      module5: {
        title: 'Uyarılar ve Bildirimler',
        desc: 'Kritik durumlar ve süreçler için otomatik uyarılar'
      },
      module6: {
        title: 'Raporlama ve Analitik',
        desc: 'Gerçek zamanlı performans izleme ve analiz'
      },
      module7: {
        title: 'Entegrasyon',
        desc: 'Mevcut kurumsal sistemlerle entegrasyon'
      },
      module8: {
        title: 'Denetim İzi',
        desc: 'Tüm işlemlerin tam takibi ve kaydı'
      },
      module9: {
        title: 'Bilgi Bankası',
        desc: 'Kurumsal bilgi yönetimi ve paylaşımı'
      },
      benefits: 'Faydalar',
      benefit1: 'Operasyonel verimlilik artar',
      benefit2: 'İnsan hatası azalır',
      benefit3: 'Süreç süreleri kısalır',
      benefit4: 'Maliyetler düşer',
      benefit5: 'Uyumluluk ve denetim kolaylaşır'
    },
    sirdas: {
      title: 'Sırdaş',
      subtitle: 'Yapay Zeka Destekli Çalışan Destek ve Bağlılık Platformu',
      button: 'Sırdaş\'ı Ziyaret Et',
      desc: 'Sırdaş, çalışan memnuniyetini ve bağlılığını artıran yapay zeka destekli bir platformdur. Çalışanlara 7/24 destek sağlar, sorularını yanıtlar ve İK süreçlerinin daha verimli yürümesine yardımcı olur.',
      module1: {
        title: 'Çalışan Desteği',
        desc: 'Çalışan sorularını yanıtlayan 7/24 yapay zeka asistanı'
      },
      module2: {
        title: 'İK Süreçleri',
        desc: 'İzin, masraf ve diğer İK süreçlerinin otomasyonu'
      },
      module3: {
        title: 'Memnuniyet Analizi',
        desc: 'Çalışan memnuniyeti ve bağlılık ölçümü'
      },
      module4: {
        title: 'Öneri ve Geri Bildirim',
        desc: 'Çalışan önerilerinin toplanması ve analizi'
      },
      module5: {
        title: 'Gizlilik',
        desc: 'Güvenli ve gizli iletişim'
      },
      module6: {
        title: 'Bildirimler',
        desc: 'Önemli duyurular ve hatırlatmalar'
      },
      benefits: 'Faydalar',
      benefit1: 'Çalışan memnuniyeti artar',
      benefit2: 'İK iş yükü azalır',
      benefit3: 'Yanıt süreleri kısalır',
      benefit4: 'İletişim gelişir',
      benefit5: 'Geri bildirim toplama kolaylaşır',
      benefit6: 'Çalışan bağlılığı artar'
    },
    dendy: {
    title: 'Dendy',
    subtitle: 'AI Destekli Müşteri İçgörü Platformu',
    button: "Dendy'yi Ziyaret Et",
    desc: 'Dendy, müşteri konuşmalarını ölçülebilir içgörülere ve net aksiyonlara çeviren yapay zeka destekli bir platformdur. WhatsApp, e-posta ve SMS üzerinden doğal diyalog akışıyla geri bildirim toplar; neyin neden bozulduğunu ve ne yapmanız gerektiğini söyler.',

    features: 'Ana Özellikler',
    feature1: 'Çok kanallı iletişim (WhatsApp, E-posta, SMS)',
    feature2: 'AI destekli duygu ve tema analizi',
    feature3: 'Gerçek zamanlı dashboard ve raporlama',
    feature4: 'KVKK ve GDPR uyumlu güvenlik',

    module1: {
      title: 'Doğal Diyalog',
      desc: 'Statik formlar yerine doğal konuşma akışı ile %70-80 tamamlanma oranı'
    },
    module2: {
      title: 'Duygu Analizi',
      desc: 'Her yanıtın duygusal tonunu otomatik tespit eder'
    },
    module3: {
      title: 'Tema Çıkarımı',
      desc: 'Konuşmalardan otomatik tema ve kategori çıkarımı'
    },
    module4: {
      title: 'Gerçek Zamanlı Dashboard',
      desc: 'Tüm kanallardan gelen geri bildirimleri tek ekranda görüntüleyin'
    },
    module5: {
      title: 'Aksiyon Önerileri',
      desc: 'AI, verilere dayanarak somut aksiyon önerileri sunar'
    },
    module6: {
      title: 'Raporlama',
      desc: 'Excel, PDF, PowerPoint ve CSV formatlarında dışa aktarım'
    },

    benefits: 'Faydalar',
    benefit1: '%45-50 maliyet azalması',
    benefit2: '%70-80 tamamlanma oranı artışı',
    benefit3: '10x hız kazancı',
    benefit4: '%25-35 NPS artışı',
    benefit5: 'Anlık içgörü ve analiz',
    benefit6: 'Ölçeklenebilir altyapı'
    },
    cta: {
      title: 'Yapay Zeka Agent Çözümlerimiz Hakkında Daha Fazla Bilgi Alın',
      subtitle: 'Otonom karar alma sistemleri ile iş süreçlerinizi optimize edin',
      button: 'İletişime Geçin'
    }
  },

  finance: {
    hero: {
      title: 'Finans Sektörü',
      subtitle: 'Veri Odaklı Finansal Zeka ve Risk Yönetimi'
    },
    intro: 'Finans sektöründe finansal riski minimize ederken portföy performansını maksimize ediyoruz. Gelişmiş analitik ve yapay zeka ile fraud tespiti, kredi skorlama ve yatırım optimizasyonu sunuyoruz.',
    features: {
      scenario: {
        title: 'Senaryo Analizi & Stres Testi',
        description: 'Makine öğrenmesi modelleri ile farklı piyasa koşullarında portföy performansını öngörüyor ve risk azaltım stratejileri geliştiriyoruz.'
      },
      anomaly: {
        title: 'Anomali Tespiti & Fraud Önleme',
        description: 'Yapay zeka destekli sistemler ile şüpheli işlemleri gerçek zamanlı tespit ediyor ve fraud\'u önlüyoruz.'
      },
      portfolio: {
        title: 'Portföy Optimizasyonu',
        description: 'Riski minimize ederken getiriyi maksimize etmek için varlık dağılımını optimize ediyor ve dinamik yatırım stratejileri oluşturuyoruz.'
      }
    },
    excellence: {
      title: 'Datafors ile Finans Sektöründe Mükemmellik',
      items: [
        'Risk analizi ve portföy optimizasyonu',
        'Gerçek zamanlı fraud tespiti ve önleme',
        'Kredi skorlama ve müşteri segmentasyonu',
        'Piyasa trend analizi ve tahminleme',
        'Regülasyon uyumu ve raporlama otomasyonu',
        'Yatırım stratejisi optimizasyonu'
      ]
    },
    applications: {
      credit: {
        title: 'Kredi Risk Değerlendirmesi',
        description: 'Doğru risk değerlendirmesi ve kredi onay kararları için yapay zeka destekli kredi skorlama modelleri.'
      },
      market: {
        title: 'Piyasa Analizi',
        description: 'Yatırım kararları için gerçek zamanlı piyasa trend analizi ve tahminsel modelleme.'
      },
      fraud: {
        title: 'Fraud Tespiti',
        description: 'Sahte işlemleri tespit etmek ve önlemek için gelişmiş anomali tespit sistemleri.'
      },
      liquidity: {
        title: 'Likidite Yönetimi',
        description: 'Tahminsel analitik ve tahminleme modelleri ile nakit akışı ve likiditeyi optimize edin.'
      }
    }
  },

  retail: {
    hero: {
      title: 'Perakende Sektörü',
      subtitle: 'Veri Odaklı Perakende Çözümleri',
    },
    intro: 'Perakende sektöründe yapay zeka ve veri analitiği ile müşteri davranışlarını anlayın, stok yönetimini optimize edin ve satışlarınızı artırın. Datafors, perakende işletmelerine özel çözümler sunarak rekabet avantajı sağlar.',
    features: {
      demand: {
        title: 'Talep Tahmini ve Stok Optimizasyonu',
        description: 'Geçmiş satış verilerini ve pazar trendlerini analiz ederek gelecekteki talebi tahmin edin. Stok seviyelerini optimize ederek maliyetleri düşürün ve müşteri memnuniyetini artırın.',
      },
      pricing: {
        title: 'Dinamik Fiyatlandırma',
        description: 'Rekabet analizi, talep esnekliği ve envanter durumuna göre otomatik fiyat optimizasyonu yapın. Karlılığı maksimize ederken pazar payınızı koruyun.',
      },
      inventory: {
        title: 'Akıllı Envanter Yönetimi',
        description: 'Yapay zeka destekli envanter yönetimi ile stok maliyetlerini düşürün, raf ömrünü optimize edin ve fire oranlarını minimize edin.',
      },
    },
    why: {
      title: 'Datafors ile Perakende Sektöründe Mükemmellik',
      reasons: {
        behavior: 'Müşteri davranış analizi ile kişiselleştirilmiş alışveriş deneyimi',
        supply: 'Tedarik zinciri optimizasyonu ile operasyonel verimlilik',
        cost: 'Maliyet düşürme ve karlılık artışı',
        profitability: 'Veri odaklı kararlarla sürdürülebilir büyüme',
      },
    },
    applications: {
      title: 'Uygulama Alanları',
      list: {
        assortment: {
          title: 'Ürün Çeşit Optimizasyonu',
          description: 'Müşteri tercihlerine göre ürün çeşitliliğini optimize edin',
        },
        promotion: {
          title: 'Promosyon Etkinliği',
          description: 'Kampanya performansını analiz edin ve optimize edin',
        },
        segmentation: {
          title: 'Müşteri Segmentasyonu',
          description: 'Hedefli pazarlama stratejileri geliştirin',
        },
        supply: {
          title: 'Tedarik Zinciri Optimizasyonu',
          description: 'Lojistik süreçlerini iyileştirin ve maliyetleri düşürün',
        },
      },
    },
  },

  energy: {
    hero: {
      title: 'Enerji Sektörü',
      subtitle: 'Akıllı Enerji Yönetimi ve Optimizasyon'
    },
    intro: 'Enerji sektöründe tüketimi optimize ederek sürdürülebilirliği artırıyoruz. Talep tahmini, şebeke optimizasyonu ve yenilenebilir enerji entegrasyonu için akıllı çözümler sunuyoruz.',
    features: {
      forecast: {
        title: 'Enerji Talep Tahmini',
        description: 'Makine öğrenmesi ile enerji talebini önceden tahmin ediyor, üretim ve dağıtım planlamasını optimize ediyoruz.'
      },
      grid: {
        title: 'Şebeke Optimizasyonu',
        description: 'Akıllı şebeke yönetimi ile enerji dağıtımını optimize ediyor, kayıpları minimize ediyoruz.'
      },
      renewable: {
        title: 'Yenilenebilir Enerji Entegrasyonu',
        description: 'Yenilenebilir enerji kaynaklarının şebekeye entegrasyonunu optimize ederek sürdürülebilirliği artırıyoruz.'
      }
    },
    excellence: {
      title: 'Datafors ile Enerji Sektöründe Mükemmellik',
      items: [
        'Enerji talep tahmini ve yük dengeleme',
        'Şebeke optimizasyonu ve akıllı sayaç analizi',
        'Yenilenebilir enerji entegrasyonu',
        'Tahminsel bakım ve ekipman izleme',
        'Enerji verimliliği analizi',
        'Gerçek zamanlı izleme ve raporlama'
      ]
    }
  },

  manufacturing: {
    hero: {
      title: 'Üretim ve İmalat Sektörü',
      subtitle: 'Akıllı Üretim ve Operasyonel Mükemmellik'
    },
    intro: 'Üretim sektöründe süreçleri optimize ederek verimliliği maksimize ediyoruz. Akıllı üretim, kalite kontrol otomasyonu ve tahminsel bakım ile operasyonel mükemmellik sağlıyoruz.',
    features: {
      scheduling: {
        title: 'Üretim Çizelgeleme',
        description: 'Üretim süreçlerini analiz ederek verimliliği artırıyor, maliyetleri düşürüyor ve üretim kapasitesini maksimize ediyoruz.'
      },
      quality: {
        title: 'Kalite Kontrol Otomasyonu',
        description: 'Görüntü işleme teknolojileri ile üretim hattında gerçek zamanlı kalite kontrolü yapıyor, hatalı parçaları otomatik tespit ediyoruz.'
      },
      supply: {
        title: 'Tedarik Zinciri Optimizasyonu',
        description: 'Tedarik zincirini optimize ederek stok maliyetlerini düşürüyor, teslimat sürelerini kısaltıyor ve operasyonel verimliliği artırıyoruz.'
      }
    },
    excellence: {
      title: 'Datafors ile Üretim Sektöründe Mükemmellik',
      items: [
        'Üretim optimizasyonu ve çizelgeleme',
        'Kalite kontrol otomasyonu',
        'Tahminsel bakım ve ekipman izleme',
        'Tedarik zinciri yönetimi',
        'Enerji tüketimi analizi',
        'Gerçek zamanlı üretim izleme'
      ]
    },
    applications: {
      predictive: {
        title: 'Tahminleyici Bakım',
        description: 'Makine öğrenmesi ile ekipman arızalarını önceden tahmin ediyor, bakım maliyetlerini azaltıyor ve üretim kesintilerini önlüyoruz.'
      },
      planning: {
        title: 'Üretim Planlama',
        description: 'Talep tahmini ve kapasite planlaması ile üretim süreçlerini optimize ediyor, verimliliği artırıyoruz.'
      },
      energyEff: {
        title: 'Enerji Verimliliği',
        description: 'Enerji tüketimini analiz ederek verimliliği artırıyor, maliyetleri düşürüyor ve sürdürülebilir şehir çözümleri',
      },
      inventory: {
        title: 'Envanter Yönetimi',
        description: 'Akıllı envanter yönetimi ile stok seviyelerini optimize ediyor, maliyetleri düşürüyor ve tedarik zincirini güçlendiriyoruz.'
      }
    }
  },

  public: {
    hero: {
      title: 'Kamu Sektörü',
      subtitle: 'Dijital Dönüşüm ve Akıllı Şehir Çözümleri'
    },
    intro: 'Kamu sektöründe dijital hizmetler aracılığıyla vatandaş memnuniyetini artırıyoruz. Veri analizi, akıllı şehir çözümleri ve e-devlet uygulamaları ile kamu verimliliğini yükseltiyoruz.',
    features: {
      digital: {
        title: 'Dijital Dönüşüm',
        description: 'Kamu kurumlarının dijital dönüşüm süreçlerini yöneterek hizmet kalitesini artırıyor ve vatandaş memnuniyetini yükseltiyoruz.'
      },
      smart: {
        title: 'Akıllı Şehir Çözümleri',
        description: 'IoT ve yapay zeka ile akıllı şehir altyapısı kurarak trafik yönetimi, enerji verimliliği ve güvenlik sistemlerini optimize ediyoruz.'
      },
      data: {
        title: 'Veri Analizi ve Karar Destek',
        description: 'Kamu verilerini analiz ederek politika yapıcılara karar destek sağlıyor, kaynak dağılımını optimize ediyoruz.'
      }
    },
    excellence: {
      title: 'Datafors ile Kamu Sektöründe Mükemmellik',
      items: [
        'Dijital dönüşüm ve e-devlet çözümleri',
        'Veri analizi ve karar destek sistemleri',
        'Akıllı şehir altyapı yönetimi',
        'Vatandaş hizmetleri optimizasyonu',
        'Güvenlik ve gözetim sistemleri',
        'Kaynak yönetimi ve planlama'
      ]
    }
  },

  mobility: {
    hero: {
      title: 'Mobilite ve Akıllı Şehirler',
      subtitle: 'Yapay Zeka ile Akıllı Ulaşım ve Şehir Yönetimi',
    },
    intro: 'Akıllı şehir ve mobilite çözümlerimiz, trafik yönetiminden toplu taşıma optimizasyonuna, otonom araçlardan şehir altyapı yönetimine kadar geniş bir yelpazede yapay zeka destekli sistemler sunar. Gerçek zamanlı veri analizi ve tahmine dayalı modelleme ile şehirlerin daha yaşanabilir, sürdürülebilir ve verimli hale gelmesini sağlıyoruz.',
    features: {
      traffic: {
        title: 'Akıllı Trafik Yönetimi',
        description: 'Gerçek zamanlı trafik akışı analizi, sinyalizasyon optimizasyonu ve trafik tahminleme ile şehir içi ulaşımı optimize ediyoruz.',
      },
      route: {
        title: 'Rota Optimizasyonu',
        description: 'Toplu taşıma ve lojistik araçları için yapay zeka destekli dinamik rota planlama ve optimizasyon çözümleri sunuyoruz.',
      },
      fleet: {
        title: 'Filo Yönetimi',
        description: 'Araç filosu takibi, bakım planlaması ve yakıt optimizasyonu ile operasyonel verimliliği artırıyoruz.',
      },
    },
    excellence: {
      title: 'Neden Datafors?',
      items: [
        'Gerçek zamanlı trafik analizi ile akıllı sinyalizasyon ve akış optimizasyonu',
        'Toplu taşıma sistemlerinde yolcu talep tahmini ve kapasite planlaması',
        'Otonom araç sistemleri için yapay zeka altyapısı ve entegrasyon',
        'Şehir altyapısı izleme ve tahmine dayalı bakım yönetimi',
        'Enerji tüketimi optimizasyonu ve sürdürülebilir şehir çözümleri',
        'Akıllı park yönetimi ve şehir içi lojistik optimizasyonu',
      ],
    },
  },

  publicSector: {
    hero: {
      title: 'Kamu Sektörü',
      subtitle: 'Dijital Dönüşüm ve Akıllı Şehir Çözümleri'
    },
    intro: 'Kamu sektöründe dijital hizmetler aracılığıyla vatandaş memnuniyetini artırıyoruz. Veri analizi, akıllı şehir çözümleri ve e-devlet uygulamaları ile kamu verimliliğini yükseltiyoruz.',
    features: {
      decision: {
        title: 'Karar Destek Sistemleri',
        description: 'Kamu kurumlarının dijital dönüşüm süreçlerini yöneterek hizmet kalitesini artırıyor ve vatandaş memnuniyetini yükseltiyoruz.'
      },
      security: {
        title: 'Veri Güvenliği ve Gizlilik',
        description: 'IoT ve yapay zeka ile akıllı şehir altyapısı kurarak trafik yönetimi, enerji verimliliği ve güvenlik sistemlerini optimize ediyoruz.'
      },
      sovereignty: {
        title: 'Veri Egemenliği',
        description: 'Kamu verilerini analiz ederek politika yapıcılara karar destek sağlıyor, kaynak dağılımını optimize ediyoruz.'
      },
      smartCity: {
        title: 'Akıllı Şehir Uygulamaları',
        description: 'Akıllı şehir teknolojileri ile şehir yönetimini optimize ediyor, vatandaş hizmetlerini iyileştiriyoruz.'
      }
    },
    excellence: {
      title: 'Datafors ile Kamu Sektöründe Mükemmellik',
      items: [
        'Dijital dönüşüm ve e-devlet çözümleri',
        'Veri analizi ve karar destek sistemleri',
        'Akıllı şehir altyapı yönetimi',
        'Vatandaş hizmetleri optimizasyonu',
        'Güvenlik ve gözetim sistemleri',
        'Kaynak yönetimi ve planlama'
      ]
    },
    applications: {
      transport: {
        title: 'Ulaşım Yönetimi',
        description: 'Akıllı ulaşım sistemleri ile trafik akışını optimize ediyor, toplu taşıma verimliliğini artırıyoruz.'
      },
      resource: {
        title: 'Kaynak Yönetimi',
        description: 'Kamu kaynaklarının etkin kullanımı için veri odaklı planlama ve optimizasyon çözümleri sunuyoruz.'
      },
      security: {
        title: 'Güvenlik Uygulamaları',
        description: 'Kamu güvenliğinde kullanılacak biometrik doğrulama sistemlerinden olay ve profil tahminleme çözümleri sunuyoruz.'
      },
      social: {
        title: 'Sosyal Hizmetler',
        description: 'Vatandaş odaklı sosyal hizmet uygulamaları ile kamu hizmetlerini dijitalleştiriyoruz.'
      }
    }
  },

  // Mobility Sector
  mobility: {
    hero: {
      title: 'Mobilite ve Akıllı Şehirler',
      subtitle: 'Yapay Zeka ile Akıllı Ulaşım ve Şehir Yönetimi',
    },
    intro: 'Akıllı şehir ve mobilite çözümlerimiz, trafik yönetiminden toplu taşıma optimizasyonuna, otonom araçlardan şehir altyapı yönetimine kadar geniş bir yelpazede yapay zeka destekli sistemler sunar. Gerçek zamanlı veri analizi ve tahmine dayalı modelleme ile şehirlerin daha yaşanabilir, sürdürülebilir ve verimli hale gelmesini sağlıyoruz.',
    features: {
      traffic: {
        title: 'Akıllı Trafik Yönetimi',
        description: 'Gerçek zamanlı trafik akışı analizi, sinyalizasyon optimizasyonu ve trafik tahminleme ile şehir içi ulaşımı optimize ediyoruz.',
      },
      route: {
        title: 'Rota Optimizasyonu',
        description: 'Toplu taşıma ve lojistik araçları için yapay zeka destekli dinamik rota planlama ve optimizasyon çözümleri sunuyoruz.',
      },
      fleet: {
        title: 'Filo Yönetimi',
        description: 'Araç filosu takibi, bakım planlaması ve yakıt optimizasyonu ile operasyonel verimliliği artırıyoruz.',
      },
    },
    excellence: {
      title: 'Neden Datafors?',
      items: [
        'Gerçek zamanlı trafik analizi ile akıllı sinyalizasyon ve akış optimizasyonu',
        'Toplu taşıma sistemlerinde yolcu talep tahmini ve kapasite planlaması',
        'Otonom araç sistemleri için yapay zeka altyapısı ve entegrasyon',
        'Şehir altyapısı izleme ve tahmine dayalı bakım yönetimi',
        'Enerji tüketimi optimizasyonu ve sürdürülebilir şehir çözümleri',
        'Akıllı park yönetimi ve şehir içi lojistik optimizasyonu',
      ],
    },
  },
};

export default tr;